import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { LuCalendar as Calendar, LuUser as User, LuUserCheck, LuMonitorSmartphone, LuUsers, LuGlobe } from 'react-icons/lu';
import ProjectDetails from './ProjectDetails';
import logo from '../../assets/logo.png';
import SocialShareBar from './SocialShareBar';

const ProjectCard = () => {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f3f4f6 0%, #e3e6ed 100%)",
      position: "relative",
      overflow: "hidden"
    }}>

      {/* Header Section */}
      <div style={{ position: "relative" }}>
        {/* Hero Image */}
        <div style={{
          height: 384,
          background: "linear-gradient(90deg, #143685 0%, #1e3a8a 100%)",
          position: "relative",
          overflow: "hidden"
        }}>
          <img
            src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80"
            alt="Digital pentru bine"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.3,
              position: "absolute",
              top: 0,
              left: 0
            }}
          />
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(90deg, rgba(20,54,133,0.8) 0%, rgba(30,58,138,0.6) 100%)"
          }}></div>

          {/* Hero Content */}
          <div style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div className="text-center text-white mx-auto px-3" style={{ maxWidth: 900 }}>
              <div
                className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4"
                style={{
                  background: "rgba(255,255,255,0.10)",
                  backdropFilter: "blur(3px)"
                }}
              >
                <LuGlobe color="#FFC72C" size={24} />
                <span className="fw-semibold">Proiect Digital pentru bine</span>
              </div>
              <h1 className="fw-bold mb-4" style={{ fontSize: "2.8rem", lineHeight: 1.1 }}>
                Digital pentru bine
              </h1>
              <p className="lead opacity-90 mx-auto" style={{ maxWidth: 700 }}>
                Sprijinim gratuit fundații și asociații în crearea unei prezențe digitale moderne, pentru o Românie mai solidară și conectată.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Share Bar */}
      <SocialShareBar />

      {/* Main Content */}
      <Container className="py-5">
        {/* Project Overview */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <div className="text-center mb-5">
                <h2 className="fw-bold mb-3" style={{ color: "#143685" }}>Obiectivul proiectului</h2>
                <div
                  style={{
                    width: 96,
                    height: 4,
                    backgroundColor: "#FFC72C",
                    margin: "0px auto 20px",
                    borderRadius: 2
                  }}
                ></div>
              </div>
              <Row className="mb-4">
                <Col md={4} className="mb-3 mb-md-0">
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC72C",
                        borderRadius: "50%"
                      }}
                    >
                      <LuUserCheck color="#143685" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#143685" }}>Accesibilitate</h5>
                    <p className="text-secondary small mb-3">Orice ONG sau fundație poate beneficia de sprijin digital gratuit</p>
                  </Card>
                </Col>
                <Col md={4} className="mb-3 mb-md-0">
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC72C",
                        borderRadius: "50%"
                      }}
                    >
                      <LuMonitorSmartphone color="#143685" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#143685" }}>Modernizare</h5>
                    <p className="text-secondary small mb-3">Prezență online adaptată nevoilor actuale ale comunităților</p>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC72C",
                        borderRadius: "50%"
                      }}
                    >
                      <LuUsers color="#143685" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#143685" }}>Solidaritate</h5>
                    <p className="text-secondary small mb-3">Construim împreună o Românie mai conectată și mai solidară</p>
                  </Card>
                </Col>
              </Row>
              <Card className="border-0 shadow-sm rounded-3 p-4" style={{ background: "#f5f7fa" }}>
                <h5 className="fw-bold mb-3" style={{ color: "#143685" }}>Context și necesitate</h5>
                <p className="text-secondary mb-2">
                  În era digitală, multe ONG-uri și fundații nu au resursele sau expertiza necesară pentru a-și crea o prezență online eficientă. 
                  Acest proiect vine să ofere sprijin gratuit, astfel încât organizațiile care ajută comunitățile să poată comunica, mobiliza și crește impactul lor în societate.
                </p>
                <p className="text-secondary">
                  PRDP pune la dispoziție echipa și resursele sale pentru digitalizarea gratuită a inițiativelor cu impact social, pentru o Românie mai unită și mai modernă.
                </p>
              </Card>
            </Card>
          </Col>
        </Row>

        {/* Project Details Section */}
        <ProjectDetails />

        {/* Footer */}
        <footer className="mt-5 mx-auto" style={{ maxWidth: 900 }}>
          <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
            <Row className="align-items-center justify-content-between">
              <Col md="auto" className="mb-3 mb-md-0 d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%"
                  }}
                >
                  <img
                    src={logo}
                    alt="PRDP"
                    width={64}
                    height={64}
                    style={{
                      borderRadius: 16,
                      background: "#ffc107",
                      marginRight: 12,
                      boxShadow: "0 2px 8px #1a2c5e",
                    }}
                  />
                </div>
                <div>
                  <h5 className="fw-bold mb-1" style={{ color: "#143685" }}>PRDP</h5>
                  <div className="text-secondary small">Pentru o Românie solidară și digitală</div>
                </div>
              </Col>
              <Col md="auto" className="text-md-end text-center">
                <div className="d-flex align-items-center gap-2 text-primary mb-1 justify-content-md-end justify-content-center">
                  <Calendar size={16} color="#143685" />
                  <span className="small fw-medium" style={{ color: "#143685" }}>Mai 2025</span>
                </div>
                <div className="d-flex align-items-center gap-2 text-primary justify-content-md-end justify-content-center">
                  <User size={16} color="#143685" />
                  <span className="small fw-medium" style={{ color: "#143685" }}>Echipa PRDP Digital</span>
                </div>
                <div className="text-secondary small mt-1">Inițiativă digitală</div>
              </Col>
            </Row>
          </Card>
        </footer>
      </Container>
    </div>
  );
};

export default ProjectCard;
